import React, { Component } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Autocomplete from "../SamaViews/NetworkViews/Autocomplete";
import Spinner from "react-bootstrap/Spinner";
import settings from "../helpers/Settings";
let { KayanURL } = settings;

class AddNewCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endWait: false
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleInputTextChange = (e) =>{
    this.setState({
      [e.target.name]: e.target.value
  })
  }
  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({ responseReady: false, sent: true, status: false});
    let resultFromDB =this.props.resultData
    this.setState({resultDB: resultFromDB});
    const Object = {
      icd: this.state.ICD_code
  };
  let dataForm = [Object];
  let icdData =dataForm[0].icd;
  if(resultFromDB&&resultFromDB.includes(icdData)){
    this.setState({resultCheck: true})
    // console.log("true")
  }else{
    this.setState({resultCheck: false})
    // console.log("false")
    let dataArrayOfJson = JSON.stringify(dataForm);
  const dataResponse = await axios.put(
    KayanURL+"api/KareemBenefits/uploadIcdExclusionList",
  {
    data: dataArrayOfJson,
    apiToken: Cookies.get("KareemId")
  }
);
  if (dataResponse) {
    let response = dataResponse.data;
    let result = {};
    if (response.success === true) {
      result = {
        message: "ICD added successfully",
        res: true,
      };
      this.props.getAllNotAllowedPrincipalICDList();
    } else {
      result = { message:response.error,
       res: false
       };
    }
    this.setState({
      status: result,
      sent: false,
      responseReady: true
    });
  } 
  }
   
  };
  render() {
    let { sent,status,responseReady,resultCheck} = this.state;
    return (
      <>
        <div className="container">
          <form onSubmit={this.onSubmit}>
            <h5>Add New Code Of ICD</h5>
              <input
              required
              onChange={this.handleInputTextChange}
              type="text"
              name="ICD_code"
              placeholder="ICD Code"
              style={{ width: "70%", padding: "8px" }}
            />
            <br />
            <input type="submit" value="Add" className="BS1" />
            <br />
            
          {sent && !responseReady ? (
          <Spinner animation="border" variant="success" />
          ) : null}
          {responseReady && status.res ? (
               <h5 style={{ color: "green" }}>{status.message}</h5>
          ): responseReady && status.res==false ? (
                <h5 style={{ color: "red" }} >{status.message}</h5>
          ) : resultCheck==true ?(
               <h5 style={{ color: "red" }} >this icd is exist enter another code!</h5>
          ):null
          }
          
          </form>
        </div>
      </>
    );
  }
}

export default AddNewCode;
